import { FETCH_CONNECTED_PROVIDERS_FAILED, FETCH_CONNECTED_PROVIDERS_START, FETCH_CONNECTED_PROVIDERS_SUCCESS } from "../actions/actionTypes";

const initialState = {
  loading: false,
  connectedProviders: [],
  flashMessage: null,
  status: null,
};

export const integrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONNECTED_PROVIDERS_START:
      return {
        ...state,
        loading: true,
        status: null,
      };

    case FETCH_CONNECTED_PROVIDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        connectedProviders: action.result || [],
        status: 200,
      };

    case FETCH_CONNECTED_PROVIDERS_FAILED:
      return {
        ...state,
        loading: false,
        connectedProviders: [],
        status: action?.error?.response?.status ?? null,
      };

    default:
      return state;
  }
};